export default {
    name: 'DetailsTab',
    props: {
        recallData: {
            type: Object,
            default: null
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        validationErrors: {
            type: Array,
            default: () => []
        },
        viewOnlyRecallFeed: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selectedDocument: null,
            editingField: null,
            editValue: '',
            tempData: {},
            originalRecallingFirmAddress: null,
            tempFieldValues: {
                recall_name: '',
                recall_id: '',
                recall_date: null,
                urgent: false,
                recalling_firm: '',
                recalling_firm_address: {
                    street: '',
                    town: '',
                    state: '',
                    zipcode: '',
                    country: ''
                },
                manufacturer: '',
                response_email: '',
                additional_contact_info: '',
                recall_type: '',
                fda_classification: '',
                description: '',
                health_risk: '',
                instructions: '',
                recall_category: '',
                isVoluntary: ''
            },
            emailValidationError: false,
            recallTypeOptions: [
                { value: 'Correction', text: 'Correction' },
                { value: 'Removal', text: 'Removal' },
                { value: 'Field Safety Notice', text: 'Field Safety Notice' }
            ],
            fdaClassificationOptions: [
                { value: 'Class I', text: 'Class I' },
                { value: 'Class II', text: 'Class II' },
                { value: 'Class III', text: 'Class III' },
                { value: 'Not Yet Classified', text: 'Not Yet Classified' }
            ],
            recallCategoryOptions: [
                { value: 'Medical Devices', text: 'Medical Devices' },
                { value: 'Pharmacy', text: 'Pharmacy' },
                { value: 'Biologics', text: 'Biologics' },
                { value: 'Food', text: 'Food' }
            ],
            isVoluntaryOptions: [
                { value: 'Supplier Voluntary', text: 'Supplier Voluntary' },
                { value: 'Regulatory Mandate', text: 'Regulatory Mandate' }
            ],
            recallMetaData: null,
            editingProduct: null, // Format: { index, field }
            editingProductIndex: null, // Track which product is being edited as a whole
            tempProductValues: {
                name: '',
                udi: '',
                lot_number: '',
                serial_number: '',
                catalog_number: '',
                model_number: '',
                part_number: '',
                version: '',
                distribution_time_period: '',
                expiration_time_period: '',
                manufactured_time_period: '',
                device_size: '',
                material_description: '',
                item_number: '',
                sku: '',
                ship_date: null,
                product_number: ''
            },
            isAddingNewProduct: false,
            editingActionId: null,
            tempActionValue: '',
            isAddingNewAction: false,
            newActionValue: '',
            editingInstructionId: null,
            tempInstructionValue: '',
            isAddingNewInstruction: false,
            newInstructionValue: '',
            editingInstructionIndex: null, // For card-based editing
            tempInstructionCardValue: '',  // For card-based editing
            editingActionIndex: null, // For action card-based editing
            tempActionCardValue: '',  // For action card-based editing
            activeToasts: new Set(), // Track active toast messages
            actionsColumnDefs: [
                {
                    headerName: 'Action',
                    field: 'action',
                    flex: 1,
                    sortable: false,
                    filter: false,
                    resizable: false,
                    wrapText: true,
                    autoHeight: true,
                    editable: false,
                    suppressMenu: true,
                    suppressRowDrag: true,
                    cellRenderer: (params) => {
                        if (params.data.isEditing) {
                            return `
                                <input 
                                    type="text" 
                                    class="form-control form-control-sm action-edit-input" 
                                    value="${params.value}" 
                                    data-index="${params.data.index}"
                                    draggable="false"
                                    ondragstart="event.preventDefault(); event.stopPropagation(); return false;"
                                    ondrag="event.preventDefault(); event.stopPropagation(); return false;"
                                    ondragend="event.preventDefault(); event.stopPropagation(); return false;"
                                    onmousedown="event.stopPropagation();"
                                    style="width: 100%; height: 100%; border: 1px solid #ced4da; padding: 4px 8px; -webkit-user-drag: none; user-select: text;"
                                />
                            `
                        }
                        return `<div style="padding: 4px 8px;">${params.value}</div>`
                    }
                },
                {
                    headerName: '',
                    field: 'actions',
                    width: 120,
                    sortable: false,
                    filter: false,
                    resizable: false,
                    pinned: 'right',
                    editable: false,
                    suppressMenu: true,
                    cellRenderer: (params) => {
                        if (params.data.isEditing) {
                            return `
                                <div style="display: flex; gap: 8px; align-items: center; justify-content: center; height: 100%;">
                                    <i class="fas fa-save" style="cursor: pointer; color: #007bff;" data-action="save" data-index="${params.data.index}"></i>
                                    <i class="fas fa-times" style="cursor: pointer; color: #6c757d;" data-action="cancel" data-index="${params.data.index}"></i>
                                </div>
                            `
                        }
                        return `
                            <div style="display: flex; gap: 8px; align-items: center; justify-content: center; height: 100%;">
                                <i class="fas fa-edit" style="cursor: pointer; color: #007bff;" data-action="edit" data-index="${params.data.index}"></i>
                                <i class="fas fa-trash" style="cursor: pointer; color: #dc3545;" data-action="delete" data-index="${params.data.index}"></i>
                            </div>
                        `
                    }
                }
            ],
            actionsGridOptions: {
                suppressHorizontalScroll: true,
                suppressRowClickSelection: true,
                suppressMovableColumns: true,
                suppressColumnVirtualisation: true,
                singleClickEdit: true,
                stopEditingWhenCellsLoseFocus: true,
                suppressRowDrag: true,
                rowDragManaged: false,
                domLayout: 'autoHeight',
                defaultColDef: {
                    sortable: false,
                    filter: false,
                    resizable: false,
                    wrapText: true,
                    autoHeight: true,
                    suppressMenu: true
                }
            },
            instructionsColumnDefs: [
                {
                    headerName: 'Instruction',
                    field: 'instruction',
                    flex: 1,
                    sortable: false,
                    filter: false,
                    resizable: false,
                    wrapText: true,
                    autoHeight: true,
                    editable: false,
                    suppressMenu: true,
                    suppressRowDrag: true,
                    cellRenderer: (params) => {
                        if (params.data.isEditing) {
                            return `
                                <input 
                                    type="text" 
                                    class="form-control form-control-sm instruction-edit-input" 
                                    value="${params.value}" 
                                    data-index="${params.data.index}"
                                    draggable="false"
                                    ondragstart="event.preventDefault(); event.stopPropagation(); return false;"
                                    ondrag="event.preventDefault(); event.stopPropagation(); return false;"
                                    ondragend="event.preventDefault(); event.stopPropagation(); return false;"
                                    onmousedown="event.stopPropagation();"
                                    style="width: 100%; height: 100%; border: 1px solid #ced4da; padding: 4px 8px; -webkit-user-drag: none; user-select: text;"
                                />
                            `
                        }
                        return `<div style="padding: 4px 8px;">${params.value}</div>`
                    }
                },
                {
                    headerName: '',
                    field: 'actions',
                    width: 120,
                    sortable: false,
                    filter: false,
                    resizable: false,
                    pinned: 'right',
                    editable: false,
                    suppressMenu: true,
                    cellRenderer: (params) => {
                        if (params.data.isEditing) {
                            return `
                                <div style="display: flex; gap: 8px; align-items: center; justify-content: center; height: 100%;">
                                    <i class="fas fa-save" style="cursor: pointer; color: #007bff;" data-action="save" data-index="${params.data.index}"></i>
                                    <i class="fas fa-times" style="cursor: pointer; color: #6c757d;" data-action="cancel" data-index="${params.data.index}"></i>
                                </div>
                            `
                        }
                        return `
                            <div style="display: flex; gap: 8px; align-items: center; justify-content: center; height: 100%;">
                                <i class="fas fa-edit" style="cursor: pointer; color: #007bff;" data-action="edit" data-index="${params.data.index}"></i>
                                <i class="fas fa-trash" style="cursor: pointer; color: #dc3545;" data-action="delete" data-index="${params.data.index}"></i>
                            </div>
                        `
                    }
                }
            ],
            instructionsGridOptions: {
                suppressHorizontalScroll: true,
                suppressRowClickSelection: true,
                suppressMovableColumns: true,
                suppressColumnVirtualisation: true,
                singleClickEdit: true,
                stopEditingWhenCellsLoseFocus: true,
                suppressRowDrag: true,
                rowDragManaged: false,
                domLayout: 'autoHeight',
                defaultColDef: {
                    sortable: false,
                    filter: false,
                    resizable: false,
                    wrapText: true,
                    autoHeight: true,
                    suppressMenu: true
                }
            }
        }
    },
    computed: {
        documentOptions() {
            if (!this.recallData?.documents || this.recallData.documents.length === 0) {
                return []
            }
            return this.recallData.documents.map((doc, index) => ({
                id: index,
                label: doc.filename || doc.input_file || `Document ${index + 1}`,
                url: doc.url,
                icon: '<i class="fas fa-file-pdf text-danger"></i>'
            }))
        },
        isEditing() {
            return !!(this.editingField ||
                     this.editingProductIndex !== null ||
                     this.editingProduct ||
                     this.isAddingNewProduct ||
                     this.editingActionId !== null ||
                     this.isAddingNewAction ||
                     this.editingInstructionId !== null ||
                     this.isAddingNewInstruction)
        },
        isMandatoryFieldsValid() {
            if (!this.recallData?.recall_info) return false
            const info = this.recallData.recall_info
            return true
        },
        hasValidationError() {
            return (fieldName) => {
                return this.validationErrors && this.validationErrors.includes(fieldName)
            }
        },
        actionsTableData() {
            if (!this.recallData?.recall_info?.actions) return []
            return this.recallData.recall_info.actions.map((action, index) => {
                const actionId = action.id || index
                return {
                    id: actionId,
                    action: action.value || action,
                    index: index,
                    isEditing: this.editingActionId === actionId
                }
            })
        },
        instructionsTableData() {
            if (!this.recallData?.recall_info?.instructions) return []
            return this.recallData.recall_info.instructions.map((instruction, index) => {
                const instructionId = instruction.id || index
                return {
                    id: instructionId,
                    instruction: instruction.value || instruction,
                    index: index,
                    isEditing: this.editingInstructionId === instructionId
                }
            })
        }
    },
    watch: {
        isEditing(newValue) {
            this.$emit('editing-state-changed', newValue)
        },
        isMandatoryFieldsValid(newValue) {
            this.$emit('validation-state-changed', newValue)
        },
        recallData: {
            handler(newValue, oldValue) {
                // Reset all editing states when navigating to a different record
                if (newValue && oldValue && newValue.id !== oldValue.id) {
                    this.resetAllEditingStates()
                }
            },
            deep: false
        }
    },
    methods: {
        formatDate(date) {
            if (!date) return '-'
            try {
                const d = new Date(date)
                if (isNaN(d.getTime())) return '-'
                const month = String(d.getMonth() + 1).padStart(2, '0')
                const day = String(d.getDate()).padStart(2, '0')
                const year = d.getFullYear()
                return `${month}/${day}/${year}`
            } catch (error) {
                return '-'
            }
        },

        formatDateForInput(date) {
            if (!date) return ''
            try {
                const d = new Date(date)
                if (isNaN(d.getTime())) return ''
                const year = d.getFullYear()
                const month = String(d.getMonth() + 1).padStart(2, '0')
                const day = String(d.getDate()).padStart(2, '0')
                return `${year}-${month}-${day}`
            } catch (error) {
                return ''
            }
        },

        getStatusClass(status) {
            const statusMap = {
                'PUBLISHED': 'badge-success',
                'PENDING': 'badge-warning',
            }
            return statusMap[status] || 'badge-secondary'
        },

        showToast(message, options = {}) {
            // Create a unique key for this toast message
            const toastKey = `${message}_${options.variant || 'default'}`
            // Check if this toast is already showing
            if (this.activeToasts.has(toastKey)) {
                return
            }
            // Add to active toasts
            this.activeToasts.add(toastKey)
            // Show the toast
            this.$bvToast.toast(message, {
                title: options.title || 'Notification',
                variant: options.variant || 'info',
                solid: true,
                toaster: 'b-toaster-top-center',
                autoHideDelay: options.autoHideDelay || 3000,
                ...options
            })
            // Remove from active toasts after it's hidden
            setTimeout(() => {
                this.activeToasts.delete(toastKey)
            }, (options.autoHideDelay || 3000) + 500)
        },

        openDocument(url) {
            if (url) {
                window.open(url, '_blank')
            }
        },

        handleDocumentSelection(documentId) {
            if (documentId !== null && documentId !== undefined) {
                const selectedDoc = this.documentOptions.find(doc => doc.id === documentId)
                if (selectedDoc && selectedDoc.url) {
                    window.open(selectedDoc.url, '_blank')
                    // Reset selection after opening
                    this.$nextTick(() => {
                        this.selectedDocument = null
                    })
                }
            }
        },
        fetchActionsData(params) {
            // For simple display-only grid with clientSide data
            const dataSource = {
                getRows: (rowParams) => {
                    const data = this.actionsTableData
                    rowParams.successCallback(data, data.length)
                }
            }
            params.api.setServerSideDatasource(dataSource)
        },
        onActionCellClicked(params) {
            const action = params.event.target.dataset.action
            const rowIndex = parseInt(params.event.target.dataset.index)
            // Get the actual data from the row
            const rowData = this.actionsTableData.find((item, idx) => item.index === rowIndex)
            if (!rowData) return

            if (action === 'edit') {
                this.startEditAction(rowData.id, rowData.index)
            } else if (action === 'save') {
                // Get the current value from the input field before saving
                const input = document.querySelector('.action-edit-input')
                if (input) {
                    this.tempActionValue = input.value
                }
                this.saveEditAction(rowData.id, rowData.index)
            } else if (action === 'cancel') {
                this.cancelEditAction()
            } else if (action === 'delete') {
                this.deleteAction(rowData.index)
            }
        },
        startEditAction(actionId, index) {
            this.editingActionId = actionId
            const action = this.recallData.recall_info.actions[index]
            // Handle both object format {id, value} and string format
            if (typeof action === 'object' && action.value) {
                this.tempActionValue = action.value
            } else {
                this.tempActionValue = action
            }
            // Refresh grid to show input textbox
            this.$nextTick(() => {
                if (this.$refs.actionsGrid && this.$refs.actionsGrid.gridApi) {
                    this.$refs.actionsGrid.gridApi.refreshServerSide({ purge: true })
                    // Focus the input after rendering
                    this.$nextTick(() => {
                        const input = document.querySelector('.action-edit-input')
                        if (input) {
                            input.focus()
                            input.select()
                            // Add event listeners
                            input.addEventListener('keyup', (e) => {
                                if (e.key === 'Enter') {
                                    this.saveEditActionFromInput(actionId, index, e.target.value)
                                } else if (e.key === 'Escape') {
                                    this.cancelEditAction()
                                }
                            })
                            input.addEventListener('input', (e) => {
                                this.tempActionValue = e.target.value
                            })
                            input.addEventListener('dragstart', (e) => {
                                e.preventDefault()
                                e.stopPropagation()
                            })
                            input.addEventListener('drag', (e) => {
                                e.preventDefault()
                                e.stopPropagation()
                            })
                        }
                    })
                }
            })
        },
        saveEditAction(actionId, index) {
            if (!this.tempActionValue || !this.tempActionValue.trim()) {
                this.showToast('Action cannot be empty', {
                    title: 'Warning',
                    variant: 'warning'
                })
                return
            }
            const currentAction = this.recallData.recall_info.actions[index]
            let updatedAction
            if (typeof currentAction === 'object' && currentAction.id) {
                updatedAction = {
                    id: currentAction.id,
                    value: this.tempActionValue
                }
            } else {
                updatedAction = {
                    value: this.tempActionValue
                }
            }
            this.$emit('action-update', { id: actionId, index, action: updatedAction })
            // Wait for parent to update data first, then clear editing state and refresh grid
            this.$nextTick(() => {
                this.$nextTick(() => {
                    this.editingActionId = null
                    this.tempActionValue = ''
                    this.$nextTick(() => {
                        this.refreshActionsGrid()
                    })
                })
            })
        },
        saveEditActionFromInput(actionId, index, value) {
            this.tempActionValue = value
            this.saveEditAction(actionId, index)
        },
        cancelEditAction() {
            this.editingActionId = null
            this.tempActionValue = ''
            this.refreshActionsGrid()
        },
        deleteAction(index) {
            this.$bvModal.msgBoxConfirm(
                'Are you sure you want to delete this action? This action cannot be undone.',
                {
                    title: 'Confirm Delete',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Delete',
                    cancelTitle: 'Cancel',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                }
            )
                .then(value => {
                    if (value) {
                        this.$emit('action-delete', index)
                        this.$nextTick(() => {
                            this.refreshActionsGrid()
                        })
                    }
                })
                .catch(() => {
                    // Error showing confirmation dialog
                })
        },
        addNewAction() {
            this.isAddingNewAction = true
            this.newActionValue = ''
        },
        saveNewAction() {
            if (!this.newActionValue.trim()) {
                this.showToast('Action cannot be empty', {
                    title: 'Warning',
                    variant: 'warning'
                })
                return
            }
            const newAction = { value: this.newActionValue }
            this.$emit('action-add', newAction)
            this.cancelNewAction()
            this.refreshActionsGrid()
        },
        cancelNewAction() {
            this.isAddingNewAction = false
            this.newActionValue = ''
        },
        refreshActionsGrid() {
            this.$nextTick(() => {
                if (this.$refs.actionsGrid && this.$refs.actionsGrid.gridApi) {
                    this.$refs.actionsGrid.gridApi.refreshServerSide({ purge: true })
                    this.$forceUpdate()
                }
            })
        },

        // Instructions methods
        fetchInstructionsData(params) {
            const dataSource = {
                getRows: (rowParams) => {
                    const data = this.instructionsTableData
                    rowParams.successCallback(data, data.length)
                }
            }
            params.api.setServerSideDatasource(dataSource)
        },
        onInstructionCellClicked(params) {
            const action = params.event.target.dataset.action
            const rowIndex = parseInt(params.event.target.dataset.index)
            const rowData = this.instructionsTableData.find((item, idx) => item.index === rowIndex)
            if (!rowData) return

            if (action === 'edit') {
                this.startEditInstruction(rowData.id, rowData.index)
            } else if (action === 'save') {
                const input = document.querySelector('.instruction-edit-input')
                if (input) {
                    this.tempInstructionValue = input.value
                }
                this.saveEditInstruction(rowData.id, rowData.index)
            } else if (action === 'cancel') {
                this.cancelEditInstruction()
            } else if (action === 'delete') {
                this.deleteInstruction(rowData.index)
            }
        },
        startEditInstruction(instructionId, index) {
            this.editingInstructionId = instructionId
            const instruction = this.recallData.recall_info.instructions[index]
            if (typeof instruction === 'object' && instruction.value) {
                this.tempInstructionValue = instruction.value
            } else {
                this.tempInstructionValue = instruction
            }
            this.$nextTick(() => {
                if (this.$refs.instructionsGrid && this.$refs.instructionsGrid.gridApi) {
                    this.$refs.instructionsGrid.gridApi.refreshServerSide({ purge: true })
                    this.$nextTick(() => {
                        const input = document.querySelector('.instruction-edit-input')
                        if (input) {
                            input.focus()
                            input.select()
                            input.addEventListener('keyup', (e) => {
                                if (e.key === 'Enter') {
                                    this.saveEditInstructionFromInput(instructionId, index, e.target.value)
                                } else if (e.key === 'Escape') {
                                    this.cancelEditInstruction()
                                }
                            })
                            input.addEventListener('input', (e) => {
                                this.tempInstructionValue = e.target.value
                            })
                            input.addEventListener('dragstart', (e) => {
                                e.preventDefault()
                                e.stopPropagation()
                            })
                            input.addEventListener('drag', (e) => {
                                e.preventDefault()
                                e.stopPropagation()
                            })
                        }
                    })
                }
            })
        },
        saveEditInstruction(instructionId, index) {
            if (!this.tempInstructionValue || !this.tempInstructionValue.trim()) {
                this.showToast('Instruction cannot be empty', {
                    title: 'Warning',
                    variant: 'warning'
                })
                return
            }
            const currentInstruction = this.recallData.recall_info.instructions[index]
            let updatedInstruction
            if (typeof currentInstruction === 'object' && currentInstruction.id) {
                updatedInstruction = {
                    id: currentInstruction.id,
                    value: this.tempInstructionValue
                }
            } else {
                updatedInstruction = {
                    value: this.tempInstructionValue
                }
            }
            this.$emit('instruction-update', { id: instructionId, index, instruction: updatedInstruction })
            this.$nextTick(() => {
                this.$nextTick(() => {
                    this.editingInstructionId = null
                    this.tempInstructionValue = ''
                    this.$nextTick(() => {
                        this.refreshInstructionsGrid()
                    })
                })
            })
        },
        saveEditInstructionFromInput(instructionId, index, value) {
            this.tempInstructionValue = value
            this.saveEditInstruction(instructionId, index)
        },
        cancelEditInstruction() {
            this.editingInstructionId = null
            this.tempInstructionValue = ''
            this.refreshInstructionsGrid()
        },
        deleteInstruction(index) {
            this.$bvModal.msgBoxConfirm(
                'Are you sure you want to delete this instruction? This action cannot be undone.',
                {
                    title: 'Confirm Delete',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Delete',
                    cancelTitle: 'Cancel',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                }
            )
                .then(value => {
                    if (value) {
                        this.$emit('instruction-delete', index)
                        this.$nextTick(() => {
                            this.refreshInstructionsGrid()
                        })
                    }
                })
                .catch(() => {
                    // Error showing confirmation dialog
                })
        },
        addNewInstruction() {
            this.isAddingNewInstruction = true
            this.newInstructionValue = ''
        },
        saveNewInstruction() {
            if (!this.newInstructionValue.trim()) {
                this.showToast('Instruction cannot be empty', {
                    title: 'Warning',
                    variant: 'warning'
                })
                return
            }
            const newInstruction = { value: this.newInstructionValue }
            this.$emit('instruction-add', newInstruction)
            this.cancelNewInstruction()
            this.refreshInstructionsGrid()
        },
        cancelNewInstruction() {
            this.isAddingNewInstruction = false
            this.newInstructionValue = ''
        },
        refreshInstructionsGrid() {
            this.$nextTick(() => {
                if (this.$refs.instructionsGrid && this.$refs.instructionsGrid.gridApi) {
                    this.$refs.instructionsGrid.gridApi.refreshServerSide({ purge: true })
                    this.$forceUpdate()
                }
            })
        },

        getInstructionsText(instructions) {
            if (!instructions || instructions.length === 0) return ''
            // Convert array of instructions to newline-separated text
            return instructions.map(item => item.value || item).join('\n')
        },

        startEdit(field, currentValue) {
            this.editingField = field
            this.emailValidationError = false
            if (field === 'recall_date') {
                // For date field, convert string to Date object
                this.tempFieldValues[field] = currentValue ? new Date(currentValue) : null
            } else if (field === 'isVoluntary') {
                // For isVoluntary field, default to 'Supplier Voluntary' if not set
                this.tempFieldValues[field] = currentValue || 'Supplier Voluntary'
            } else if (field === 'recalling_firm_address') {
                // Store the original address for comparison
                this.originalRecallingFirmAddress = currentValue ? {
                    street: currentValue.street || '',
                    town: currentValue.town || '',
                    state: currentValue.state || '',
                    zipcode: currentValue.zipcode || '',
                    country: currentValue.country || ''
                } : {
                    street: '',
                    town: '',
                    state: '',
                    zipcode: '',
                    country: ''
                }
                // For recalling_firm_address, handle object with nested properties
                this.tempFieldValues[field] = currentValue ? {
                    street: currentValue.street || '',
                    town: currentValue.town || '',
                    state: currentValue.state || '',
                    zipcode: currentValue.zipcode || '',
                    country: currentValue.country || ''
                } : {
                    street: '',
                    town: '',
                    state: '',
                    zipcode: '',
                    country: ''
                }
            }
            else if (field === 'urgent') {
                // For isVoluntary field, default to 'Supplier Voluntary' if not set
                this.tempFieldValues[field] = currentValue || false
            } else {
                this.tempFieldValues[field] = currentValue || ''
            }
        },

        cancelEdit() {
            this.editingField = null
            this.emailValidationError = false
            // Clear all temp values
            this.tempFieldValues = {
                recall_name: '',
                recall_id: '',
                recall_date: null,
                urgent: false,
                recalling_firm: '',
                recalling_firm_address: {
                    street: '',
                    town: '',
                    state: '',
                    zipcode: '',
                    country: ''
                },
                manufacturer: '',
                response_email: '',
                additional_contact_info: '',
                recall_type: '',
                fda_classification: '',
                description: '',
                health_risk: '',
                instructions: '',
                recall_category: ''
            }
        },

        saveEdit(field) {
            // Validate email if the field is response_email
            if (field === 'response_email' && this.tempFieldValues[field]) {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
                if (!emailRegex.test(this.tempFieldValues[field])) {
                    this.emailValidationError = true
                    this.showToast('Please enter a valid email address', {
                        title: 'Invalid Email',
                        variant: 'danger'
                    })
                    return
                }
            }

            this.emailValidationError = false
            // Handle recalling_firm_address separately to detect individual field changes
            if (field === 'recalling_firm_address') {
                const oldAddress = this.originalRecallingFirmAddress || {}
                const newAddress = this.tempFieldValues[field]
                // Check each address field for changes and emit individually
                const addressFields = ['street', 'town', 'state', 'zipcode', 'country']
                let hasChanges = false
                addressFields.forEach(addressField => {
                    const oldValue = oldAddress[addressField] || ''
                    const newValue = newAddress[addressField] || ''
                    if (oldValue !== newValue) {
                        hasChanges = true
                        this.$emit('field-update', {
                            field: `recalling_firm_address.${addressField}`,
                            value: newValue,
                            oldValue: oldValue
                        })
                    }
                })
                if (!hasChanges) {
                    this.showToast('No changes detected', {
                        title: 'Info',
                        variant: 'info',
                        autoHideDelay: 2000
                    })
                }
                // Clear the stored original address
                this.originalRecallingFirmAddress = null
            } else {
                // Emit the save event with field name and new value
                this.$emit('field-update', {
                    field: field,
                    value: this.tempFieldValues[field]
                })
            }
            this.editingField = null
            // Clear the temp value after saving
            if (field === 'recall_date') {
                this.tempFieldValues[field] = null
            } else if (field === 'urgent') {
                this.tempFieldValues[field] = false
            } else if (field === 'recalling_firm_address') {
                this.tempFieldValues[field] = {
                    street: '',
                    town: '',
                    state: '',
                    zipcode: '',
                    country: ''
                }
            } else {
                this.tempFieldValues[field] = ''
            }
        },

        startEditProduct(productIndex, field, currentValue) {
            this.editingProduct = { index: productIndex, field: field }
            if (field === 'ship_date') {
                this.tempProductValues[field] = currentValue ? new Date(currentValue) : null
            } else {
                this.tempProductValues[field] = currentValue || ''
            }
        },

        startEditWholeProduct(productIndex, product) {
            // Cancel add new product mode if active
            if (this.isAddingNewProduct) {
                this.isAddingNewProduct = false
            }
            this.editingProductIndex = productIndex
            // Load all product values into temp
            this.tempProductValues = {
                name: product.name || '',
                udi: product.udi || '',
                lot_number: product.lot_number || '',
                serial_number: product.serial_number || '',
                catalog_number: product.catalog_number || '',
                model_number: product.model_number || '',
                part_number: product.part_number || '',
                version: product.version || '',
                distribution_start_date: product.distribution_start_date ? new Date(product.distribution_start_date) : null,
                distribution_end_date: product.distribution_end_date ? new Date(product.distribution_end_date) : null,
                expiration_start_date: product.expiration_start_date ? new Date(product.expiration_start_date) : null,
                expiration_end_date: product.expiration_end_date ? new Date(product.expiration_end_date) : null,
                manufactured_start_date: product.manufactured_start_date ? new Date(product.manufactured_start_date) : null,
                manufactured_end_date: product.manufactured_end_date ? new Date(product.manufactured_end_date) : null,
                device_size: product.device_size || '',
                material_description: product.material_description || '',
                item_number: product.item_number || '',
                sku: product.sku || '',
                ship_date: product.ship_date ? new Date(product.ship_date) : null,
                product_number: product.product_number || ''
            }
        },

        cancelEditProduct() {
            this.editingProduct = null
            this.editingProductIndex = null
            // Clear all temp product values
            this.tempProductValues = {
                name: '',
                udi: '',
                lot_number: '',
                serial_number: '',
                catalog_number: '',
                model_number: '',
                part_number: '',
                version: '',
                distribution_start_date: null,
                distribution_end_date: null,
                expiration_start_date: null,
                expiration_end_date: null,
                manufactured_start_date: null,
                manufactured_end_date: null,
                device_size: '',
                material_description: '',
                item_number: '',
                sku: '',
                ship_date: null,
                product_number: ''
            }
        },

        saveWholeProduct(productIndex) {
            // Validate product name is required
            if (!this.tempProductValues.name || this.tempProductValues.name.trim() === '') {
                this.showToast('Product name is required', {
                    title: 'Validation Error',
                    variant: 'danger'
                })
                return
            }

            // Validate Distribution dates
            if (this.tempProductValues.distribution_start_date && this.tempProductValues.distribution_end_date) {
                const startDate = new Date(this.tempProductValues.distribution_start_date)
                const endDate = new Date(this.tempProductValues.distribution_end_date)
                if (endDate < startDate) {
                    this.showToast('Distribution End Date must be greater than or equal to Distribution Start Date', {
                        title: 'Validation Error',
                        variant: 'danger'
                    })
                    return
                }
            }

            // Validate Expiration dates
            if (this.tempProductValues.expiration_start_date && this.tempProductValues.expiration_end_date) {
                const startDate = new Date(this.tempProductValues.expiration_start_date)
                const endDate = new Date(this.tempProductValues.expiration_end_date)
                if (endDate < startDate) {
                    this.showToast('Expiration End Date must be greater than or equal to Expiration Start Date', {
                        title: 'Validation Error',
                        variant: 'danger'
                    })
                    return
                }
            }

            // Validate Manufactured dates
            if (this.tempProductValues.manufactured_start_date && this.tempProductValues.manufactured_end_date) {
                const startDate = new Date(this.tempProductValues.manufactured_start_date)
                const endDate = new Date(this.tempProductValues.manufactured_end_date)
                if (endDate < startDate) {
                    this.showToast('Manufactured End Date must be greater than or equal to Manufactured Start Date', {
                        title: 'Validation Error',
                        variant: 'danger'
                    })
                    return
                }
            }

            // Emit event to update entire product
            this.$emit('product-update-all', {
                index: productIndex,
                product: { ...this.tempProductValues }
            })
            this.editingProductIndex = null
            this.showToast('Product updated successfully', {
                title: 'Success',
                variant: 'success',
                solid: true,
                toaster: 'b-toaster-top-center',
                autoHideDelay: 3000
            })
            // Clear temp values
            this.tempProductValues = {
                name: '',
                udi: '',
                lot_number: '',
                serial_number: '',
                catalog_number: '',
                model_number: '',
                part_number: '',
                version: '',
                distribution_start_date: null,
                distribution_end_date: null,
                expiration_start_date: null,
                expiration_end_date: null,
                manufactured_start_date: null,
                manufactured_end_date: null,
                device_size: '',
                material_description: '',
                item_number: '',
                sku: '',
                ship_date: null,
                product_number: ''
            }
        },

        saveEditProduct(productIndex, field) {
            // Get current product data to check related dates
            const currentProduct = this.recallData.recall_info.product_list[productIndex]

            // Validate Distribution dates
            if (field === 'distribution_start_date' || field === 'distribution_end_date') {
                const startDate = field === 'distribution_start_date'
                    ? new Date(this.tempProductValues[field])
                    : (currentProduct.distribution_start_date ? new Date(currentProduct.distribution_start_date) : null)
                const endDate = field === 'distribution_end_date'
                    ? new Date(this.tempProductValues[field])
                    : (currentProduct.distribution_end_date ? new Date(currentProduct.distribution_end_date) : null)

                if (startDate && endDate && endDate < startDate) {
                    this.showToast('Distribution End Date must be greater than or equal to Distribution Start Date', {
                        title: 'Validation Error',
                        variant: 'danger'
                    })
                    return
                }
            }

            // Validate Expiration dates
            if (field === 'expiration_start_date' || field === 'expiration_end_date') {
                const startDate = field === 'expiration_start_date'
                    ? new Date(this.tempProductValues[field])
                    : (currentProduct.expiration_start_date ? new Date(currentProduct.expiration_start_date) : null)
                const endDate = field === 'expiration_end_date'
                    ? new Date(this.tempProductValues[field])
                    : (currentProduct.expiration_end_date ? new Date(currentProduct.expiration_end_date) : null)

                if (startDate && endDate && endDate < startDate) {
                    this.showToast('Expiration End Date must be greater than or equal to Expiration Start Date', {
                        title: 'Validation Error',
                        variant: 'danger',
                        autoHideDelay: 3000
                    })
                    return
                }
            }

            // Validate Manufactured dates
            if (field === 'manufactured_start_date' || field === 'manufactured_end_date') {
                const startDate = field === 'manufactured_start_date'
                    ? new Date(this.tempProductValues[field])
                    : (currentProduct.manufactured_start_date ? new Date(currentProduct.manufactured_start_date) : null)
                const endDate = field === 'manufactured_end_date'
                    ? new Date(this.tempProductValues[field])
                    : (currentProduct.manufactured_end_date ? new Date(currentProduct.manufactured_end_date) : null)

                if (startDate && endDate && endDate < startDate) {
                    this.showToast('Manufactured End Date must be greater than or equal to Manufactured Start Date', {
                        title: 'Validation Error',
                        variant: 'danger',
                        autoHideDelay: 3000
                    })
                    return
                }
            }

            // Emit the save event with product index, field name and new value
            this.$emit('product-update', {
                index: productIndex,
                field: field,
                value: this.tempProductValues[field]
            })
            this.editingProduct = null
            // Clear the temp value after saving
            if (field === 'ship_date') {
                this.tempProductValues[field] = null
            } else {
                this.tempProductValues[field] = ''
            }
        },

        deleteProduct(productIndex) {
            this.$bvModal.msgBoxConfirm(
                'Are you sure you want to delete this product? This action cannot be undone.',
                {
                    title: 'Confirm Delete',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Delete',
                    cancelTitle: 'Cancel',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                }
            )
                .then(value => {
                    if (value) {
                        this.$emit('product-delete', productIndex)
                        this.showToast('Product deleted successfully', {
                            title: 'Success',
                            variant: 'success',
                            autoHideDelay: 3000
                        })
                    }
                })
                .catch(() => {
                    // Error showing confirmation dialog
                })
        },

        // Card-based instruction methods
        startEditInstructionCard(index, instruction) {
            this.editingInstructionIndex = index
            this.tempInstructionCardValue = instruction.value || ''
        },

        saveInstructionCard(index) {
            if (!this.tempInstructionCardValue.trim()) {
                this.showToast('Instruction cannot be empty', {
                    title: 'Warning',
                    variant: 'warning'
                })
                return
            }

            const updatedInstruction = {
                ...this.recallData.recall_info.instructions[index],
                value: this.tempInstructionCardValue
            }

            this.$emit('instruction-update', { index, instruction: updatedInstruction })

            this.editingInstructionIndex = null
            this.tempInstructionCardValue = ''
            this.refreshInstructionsGrid()
        },

        cancelEditInstructionCard() {
            this.editingInstructionIndex = null
            this.tempInstructionCardValue = ''
        },

        deleteInstructionCard(index) {
            this.$bvModal.msgBoxConfirm(
                'Are you sure you want to delete this instruction? This action cannot be undone.',
                {
                    title: 'Confirm Delete',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Delete',
                    cancelTitle: 'Cancel',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                }
            )
                .then(value => {
                    if (value) {
                        this.$emit('instruction-delete', index)
                        this.showToast('Instruction deleted successfully', {
                            title: 'Success',
                            variant: 'success',
                            autoHideDelay: 2000
                        })
                        this.refreshInstructionsGrid()
                    }
                })
                .catch(() => {
                    // Error showing confirmation dialog
                })
        },

        // Action card methods for responsive table
        startEditActionCard(index, action) {
            this.editingActionIndex = index
            this.tempActionCardValue = action.value || ''
        },

        saveActionCard(index) {
            if (!this.tempActionCardValue.trim()) {
                this.showToast('Action cannot be empty', {
                    title: 'Warning',
                    variant: 'warning'
                })
                return
            }

            const updatedAction = {
                ...this.recallData.recall_info.actions[index],
                value: this.tempActionCardValue
            }

            this.$emit('action-update', { index, action: updatedAction })

            this.editingActionIndex = null
            this.tempActionCardValue = ''
            this.refreshActionsGrid()
        },

        cancelEditActionCard() {
            this.editingActionIndex = null
            this.tempActionCardValue = ''
        },

        deleteActionCard(index) {
            this.$bvModal.msgBoxConfirm(
                'Are you sure you want to delete this action? This action cannot be undone.',
                {
                    title: 'Confirm Delete',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Delete',
                    cancelTitle: 'Cancel',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                }
            )
                .then(value => {
                    if (value) {
                        this.$emit('action-delete', index)
                        this.refreshActionsGrid()
                    }
                })
                .catch(() => {
                    // Error showing confirmation dialog
                })
        },

        addNewProduct() {
            // Cancel any ongoing product edit first
            if (this.editingProductIndex !== null) {
                this.editingProductIndex = null
            }
            this.isAddingNewProduct = true
            // Reset temp values for new product
            this.tempProductValues = {
                name: '',
                udi: '',
                lot_number: '',
                serial_number: '',
                catalog_number: '',
                model_number: '',
                part_number: '',
                version: '',
                distribution_start_date: null,
                distribution_end_date: null,
                expiration_start_date: null,
                expiration_end_date: null,
                manufactured_start_date: null,
                manufactured_end_date: null,
                device_size: '',
                material_description: '',
                item_number: '',
                sku: '',
                ship_date: null,
                product_number: ''
            }
        },

        cancelNewProduct() {
            this.isAddingNewProduct = false
            // Clear temp values
            this.tempProductValues = {
                name: '',
                udi: '',
                lot_number: '',
                serial_number: '',
                catalog_number: '',
                model_number: '',
                part_number: '',
                version: '',
                distribution_start_date: null,
                distribution_end_date: null,
                expiration_start_date: null,
                expiration_end_date: null,
                manufactured_start_date: null,
                manufactured_end_date: null,
                device_size: '',
                material_description: '',
                item_number: '',
                sku: '',
                ship_date: null,
                product_number: ''
            }
        },

        saveNewProduct() {
            // Validate at least name is provided
            if (!this.tempProductValues.name || this.tempProductValues.name.trim() === '') {
                this.showToast('Product name is required', {
                    title: 'Validation Error',
                    variant: 'danger',
                    autoHideDelay: 3000
                })
                return
            }

            // Validate Distribution dates
            if (this.tempProductValues.distribution_start_date && this.tempProductValues.distribution_end_date) {
                const startDate = new Date(this.tempProductValues.distribution_start_date)
                const endDate = new Date(this.tempProductValues.distribution_end_date)
                if (endDate < startDate) {
                    this.showToast('Distribution End Date must be greater than or equal to Distribution Start Date', {
                        title: 'Validation Error',
                        variant: 'danger',
                        autoHideDelay: 3000
                    })
                    return
                }
            }

            // Validate Expiration dates
            if (this.tempProductValues.expiration_start_date && this.tempProductValues.expiration_end_date) {
                const startDate = new Date(this.tempProductValues.expiration_start_date)
                const endDate = new Date(this.tempProductValues.expiration_end_date)
                if (endDate < startDate) {
                    this.showToast('Expiration End Date must be greater than or equal to Expiration Start Date', {
                        title: 'Validation Error',
                        variant: 'danger',
                        autoHideDelay: 3000
                    })
                    return
                }
            }

            // Validate Manufactured dates
            if (this.tempProductValues.manufactured_start_date && this.tempProductValues.manufactured_end_date) {
                const startDate = new Date(this.tempProductValues.manufactured_start_date)
                const endDate = new Date(this.tempProductValues.manufactured_end_date)
                if (endDate < startDate) {
                    this.showToast('Manufactured End Date must be greater than or equal to Manufactured Start Date', {
                        title: 'Validation Error',
                        variant: 'danger',
                        autoHideDelay: 3000
                    })
                    return
                }
            }

            // Emit event to add new product
            this.$emit('product-add', { ...this.tempProductValues })
            this.isAddingNewProduct = false
            this.showToast('Product added successfully', {
                title: 'Success',
                variant: 'success',
                autoHideDelay: 3000
            })
            // Clear temp values
            this.tempProductValues = {
                name: '',
                udi: '',
                lot_number: '',
                serial_number: '',
                catalog_number: '',
                model_number: '',
                part_number: '',
                version: '',
                distribution_start_date: null,
                distribution_end_date: null,
                expiration_start_date: null,
                expiration_end_date: null,
                manufactured_start_date: null,
                manufactured_end_date: null,
                device_size: '',
                material_description: '',
                item_number: '',
                sku: '',
                ship_date: null,
                product_number: ''
            }
        },

        resetAllEditingStates() {
            // Reset field editing
            this.editingField = null
            this.emailValidationError = false
            this.tempFieldValues = {
                recall_name: '',
                recall_id: '',
                recall_date: null,
                urgent: false,
                recalling_firm: '',
                recalling_firm_address: {
                    street: '',
                    town: '',
                    state: '',
                    zipcode: '',
                    country: ''
                },
                manufacturer: '',
                response_email: '',
                additional_contact_info: '',
                recall_type: '',
                fda_classification: '',
                description: '',
                health_risk: '',
                instructions: '',
                recall_category: '',
                isVoluntary: ''
            }

            // Reset product editing
            this.editingProduct = null
            this.editingProductIndex = null
            this.isAddingNewProduct = false
            this.tempProductValues = {
                name: '',
                udi: '',
                lot_number: '',
                serial_number: '',
                catalog_number: '',
                model_number: '',
                part_number: '',
                version: '',
                distribution_start_date: null,
                distribution_end_date: null,
                expiration_start_date: null,
                expiration_end_date: null,
                manufactured_start_date: null,
                manufactured_end_date: null,
                device_size: '',
                material_description: '',
                item_number: '',
                sku: '',
                ship_date: null,
                product_number: ''
            }

            // Reset action editing
            this.editingActionId = null
            this.tempActionValue = ''
            this.isAddingNewAction = false
            this.newActionValue = ''

            // Reset instruction editing
            this.editingInstructionId = null
            this.tempInstructionValue = ''
            this.isAddingNewInstruction = false
            this.newInstructionValue = ''
        }
    }
}